module.exports = __webpack_public_path__ + "img/粤港澳大湾区（广州）科技金融中心.01bf356d.png";